import React, { useState } from 'react';
import Header from "./partials/Header";
import { Link } from "react-router-dom";
import AccountIntro from './partials/AccountIntro';

export default function RecoverPassword() {
    const API_AUTH_URL = process.env.REACT_APP_AUTH_API_URL;

    const [sent, setSent] = useState(false);

    const [formData, setFormData] = useState({
        email: '',
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }

        if (errors.general) {
            setErrors(prev => ({
                ...prev,
                general: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!formData.email) newErrors.email = 'Campo obbligatorio';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);

        const submitData = new FormData();
        submitData.append('email', formData.email);
        submitData.append('flag', 'p');

        try {
            const response = await fetch(
                `${API_AUTH_URL}/auth/recovercredentials`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                    },
                    body: submitData
                }
            );

            if (!response.ok) throw new Error('Non è stato possibile inviare la richiesta. Riprova tra poco.');
            setSent(true);
        } catch (error) {
            setErrors({
                general: error.message || 'Errore del server'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ef-page ef-auth-page ef-account-page ef-recovery-page min-h-screen">
            <Header />
            <AccountIntro title="Ritrova il tuo accesso." backTo="/login" backLabel="Torna al login">Inserisci l’email del tuo account. Ti invieremo le istruzioni per scegliere una nuova password.</AccountIntro>

            <form onSubmit={handleSubmit}>
                <div className="max-w-2xl mx-auto signup-form-background border-radius md:shadow-2xl p-6 space-y-7 mt-6">
                    {errors.general && (
                        <p role="alert" className="ef-account-notice ef-account-notice--error">
                            {errors.general}
                        </p>
                    )}

                    {sent ? <div role="status" className="ef-account-notice">
                        Se l’indirizzo è associato a un account, riceverai un’email con il link per recuperare la password. Controlla anche la cartella spam.
                    </div> : <>
                    <div>
                        <label htmlFor="recovery-email" className="block font-bold mb-2">Email del tuo account</label>
                        <input
                            type="email"
                            name="email"
                            id="recovery-email"
                            autoComplete="email"
                            required
                            placeholder="Inserisci l'indirizzo email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-gray-200 border-radius focus:outline-none focus:ring-2 focus:ring-primary transition"
                        />
                        {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                    </div>

                    <div>
                        <button
                            type="submit"
                            disabled={loading}
                            className={`bg-primary w-full text-white py-2 text-lg border-radius ${
                                loading ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                        >
                            {loading ? 'Richiesta in corso...' : 'Invia il link di recupero'}
                        </button>
                    </div>
                    </>}
                    <p className="text-center"><Link to="/login">Torna al login <span aria-hidden="true">→</span></Link></p>
                </div>
            </form>
        </div>
    );
}
